import React, { useState } from 'react';
import { User, LogOut, Settings } from 'lucide-react';
import { useTokens } from '../context/ThemeContext';

export const TOPBAR_HEIGHT = '56px';

function Topbar({ user, onLogout, onUserUpdate, onOpenSettings }) {
  const t = useTokens();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const initials = user?.name
    ? user.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : null;

  const openSettings = (section = 'profile') => {
    onOpenSettings(section);
    setDropdownOpen(false);
  };

  return (
    <>
      <header style={{ position: 'fixed', top: 0, left: 0, right: 0, height: TOPBAR_HEIGHT, backgroundColor: t.surface, borderBottom: `1px solid ${t.border}`, display: 'flex', alignItems: 'center', padding: '0 24px', zIndex: 20 }}>
        <span style={{ fontSize: '20px', fontWeight: '600', color: t.textSlate, letterSpacing: '0.02em', flex: 1 }}>nura</span>

        <div style={{ position: 'relative', flexShrink: 0 }}>
          <button
            onClick={() => setDropdownOpen(o => !o)}
            style={{ display: 'flex', alignItems: 'center', padding: '4px', border: 'none', borderRadius: '50%', cursor: 'pointer', transition: 'background-color 0.15s', backgroundColor: dropdownOpen ? t.navActive : 'transparent' }}
          >
            <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: t.avatarBg, color: t.avatarText, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '600' }}>
              {initials || <User size={14} />}
            </div>
          </button>

          {dropdownOpen && (
            <>
              <div style={{ position: 'fixed', inset: 0, zIndex: 29 }} onClick={() => setDropdownOpen(false)} />
              <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, backgroundColor: t.surface, border: `1px solid ${t.border}`, borderRadius: '10px', boxShadow: t.dropdownShadow, zIndex: 30, minWidth: '160px', overflow: 'hidden' }}>
                <button
                  onClick={() => openSettings('profile')}
                  style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px 16px', border: 'none', backgroundColor: 'transparent', color: t.text, fontSize: '14px', fontWeight: '500', cursor: 'pointer', textAlign: 'left' }}
                >
                  <Settings size={15} />
                  <span>Settings</span>
                </button>
                <div style={{ height: '1px', backgroundColor: t.borderLight }} />
                <button
                  onClick={onLogout}
                  style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px 16px', border: 'none', backgroundColor: 'transparent', color: t.danger, fontSize: '14px', fontWeight: '500', cursor: 'pointer', textAlign: 'left' }}
                >
                  <LogOut size={15} />
                  <span>Sign out</span>
                </button>
              </div>
            </>
          )}
        </div>
      </header>

    </>
  );
}

export default Topbar;
